import * as actions from '../services'
import * as types from './mutations-types'
import { addFlash } from 'src/app/components/shareds/flash/vuex/mutations-types'
import { setPagination } from 'src/app/components/shareds/pagination/vuex/mutations-types'
import { t } from 'src/utils/form'

export const loadAccessUsers = (context, payload) => {
  return actions.getAccessUsers(payload)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(types.setAccessUsers, response.data.users)
      context.commit(setPagination, response.data.meta)
    }
    return response
  })
}

export const loadAccessUser = (context, payload) => {
  return actions.getAccessUser(payload)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(types.setAccessUser, response.data.user)
    }
    return response
  })
}

export const createAccessUser = (context, payload) => {
  return actions.newAccessUser(payload)
  .then(function (response) {
    if (response && response.status === 200 || response.status === 201) {
      context.commit(addFlash, { message: t(context, 'access_users.messages.created_with_success'), type: 'ls-alert-success' })
      context.commit(types.setUser, response.data.user)
    }
    return response
  })
}

export const editAccessUser = (context, payload) => {
  return actions.updateAccessUser(payload)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(addFlash, { message: t(context, 'access_users.messages.changed_with_success', { name: response.data.user.name }), type: 'ls-alert-success' })
      context.commit(types.setUser, response.data.user)
    }
    return response
  })
}

export const destroyAccessUser = (context, payload) => {
  return actions.destroyAccessUser(payload.id)
  .then(function (response) {
    if (response && response.status === 200 || response.status === 201) {
      context.commit(addFlash, { message: t(context, 'access_users.messages.deleted_with_success'), type: 'ls-alert-success' })
      loadAccessUsers(context, payload)
    }
    return response
  })
}




// WEBPACK FOOTER //
// ./src/app/pages/access_users/vuex/actions.js